import type { Palette, Theme } from "@mui/material";

export function getPaletteColor(theme: Theme, color: string | undefined) {
  return theme.palette[color as keyof Omit<Palette, "inherit">] as any;
}
